<template>
  <ModalV2
    title="Passer au forfait annuel"
    :close-icon="icons.close"
    :visible="isVisible"
    @close="close"
  >
    <template #body>
      <div class="text-center">
        <img alt="An image" class="mbs" :src="icons.commonLargeAnnualPremium" />
        <h4 class="mbm">
          {{ unPrettierNuggets.saveOverYearlyCopy(subscription) }}
        </h4>
        <div class="flex-container align-center">
          <div class="text-left text-medium">
            <p class="mbs">
              <img alt="An image" :src="icons.commonSmallCheckBlue" />
              {{ unPrettierNuggets.annualUpgradeOnlyCopy(subscription) }}
            </p>
            <p class="mbs">
              <img alt="An image" :src="icons.commonSmallCheckBlue" />
              {{ unPrettierNuggets.saveOverMonthToMonthCopy(subscription) }}
            </p>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="row align-center">
        <div class="column shrink">
          <button
            v-if="subscription.subscriptionAnnualUpgradeUrl"
            class="mbs button tiny hollow secondary tiny full-width form-stacking__item"
            @click="next"
          >
            Annuler l'abonnement
          </button>
        </div>
        <div class="column shrink">
          <button
            type="button"
            class="button tiny mbn prm plm"
            @click="upgrade"
          >
            Mettre à niveau maintenant
          </button>
        </div>
      </div>
    </template>
  </ModalV2>
</template>

<script>
import ModalV2 from '../../../../shared/Modal/ModalV2.vue';

export default {
  components: {
    ModalV2,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    icons: {
      type: Object,
      required: true,
    },
    subscription: {
      type: Object,
      required: true,
    },
    cancelSubscriptionFlow: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      unPrettierNuggets: {
        saveOverYearlyCopy: (subscription) => {
          return `Économisez ${subscription.percentSavedWithYearly}% avec un forfait annuel`;
        },
        annualUpgradeOnlyCopy: (subscription) => {
          return `La mise à niveau annuelle de ${subscription.subscriptionFor} ne coûte que ${subscription.annualYearlyCostCopy}/an`;
        },
        saveOverMonthToMonthCopy: (subscription) => {
          return `Économisez 0 %/an d'un mois à l'autre !`;
        },
      },
    };
  },
  computed: {
    isVisible() {
      return this.visible;
    },
  },
  methods: {
    upgrade() {
      window.location.href = this.subscription.subscriptionAnnualUpgradeUrl;
    },
    close() {
      this.$emit('close');
    },
    next() {
      this.$emit('next');
    },
  },
};
</script>
